import { ConfigurationCaseTypeLaboratoryResponse } from '@/modules/configurationModule/detail/local-cases/local-case-types/services/local-case-types.dto'
import { uniqueId } from 'lodash'

export enum LocalCasesTypesModalTabIndex {
    FORM_DATA = 0,
    SAMPLE_TYPES = 1
}

export interface LocalCasesTypesModalState {
    activeTabIndex: number
    selectedRow: ConfigurationCaseTypeLaboratoryResponse
    modalUID: string
}
export const initialLocalCasesTypesModalState =
    (): LocalCasesTypesModalState => ({
        activeTabIndex: LocalCasesTypesModalTabIndex.FORM_DATA,
        selectedRow: {
            laboratory: {
                labActive: false,
                labExternalId: '',
                labId: 0,
                labName: ''
            },
            description: '',
            id: 0,
            caseType: {
                active: false,
                description: '',
                id: 0
            },
            serial: '',
            active: true
        },
        modalUID: uniqueId()
    })
